import { defineComponent as _defineComponent } from 'vue'

import { ConsultantMissionLifecycle } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantBilling',
  props: {
    mission: null
  },
  setup(__props: any) {



const { formatDate } = useUtilities()

return { __sfc: true,formatDate, Icon }
}

})